<!-- Modern Help Search Page -->
<div class="modern-help-page">
  <!-- Main Content -->
  <main class="main-content">

    <button class="btn primary-btn go-help-btn" (click)="goBack()">
      <ng-icon name="tablerArrowLeft"></ng-icon>
      Go Help
    </button>


    <!-- Welcome Section -->
    <div class="welcome-section">
      <div class="content-container">



        <!-- Go Help Button -->
        <div class="main-search">


          <h1 class="welcome-title">Welcome! How can we help?</h1>

          <div class="search-wrapper">
            <div class="search-icon-container">
              <span class="search-svg-icon">
                <ng-icon name="tablerSearch"></ng-icon>
              </span>
              <mat-form-field appearance="fill" class="search-field">
                <input matInput [formControl]="searchControl" (input)="searchFilter()"
                  placeholder="Search for help topics, tutorials, or frequently asked questions..."
                  [matAutocomplete]="auto" class="form-control main-search-input">
                <mat-autocomplete #auto="matAutocomplete" class="modern-autocomplete">
                  <mat-option *ngFor="let option of temphelpDetails" (click)="viewPage(option)" [value]="option.question">
                    <div class="autocomplete-option">
                      <div class="option-content">
                        <div class="option-title">{{option.question}}</div>
                      </div>
                    </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>

        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-section" *ngIf="loadAPIcall">
        <ng-container *ngFor="let item of 5 | times; let i = index">
          <app-common-skeleton [NameOftheScreen]="'helpModule'"></app-common-skeleton>
        </ng-container>
      </div>

      <!-- Video Content Sections -->
      <div class="video-sections" *ngIf="!loadAPIcall">

        <!-- Jobs Section -->
        <section class="video-section" *ngIf="jobVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Jobs</h2>

          </div>

          <div class="video-grid" id="jobs-grid">
            <div class="video-card" *ngFor="let video of jobVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>

        <!-- Candidates Section -->
        <section class="video-section" *ngIf="candidateVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Candidates</h2>

          </div>

          <div class="video-grid" id="candidates-grid">
            <div class="video-card" *ngFor="let video of candidateVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>

        <!-- Workspace Section -->
        <section class="video-section" *ngIf="teamVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Workspace</h2>

          </div>

          <div class="video-grid" id="workspace-grid">
            <div class="video-card" *ngFor="let video of teamVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>

        <!-- Additional sections for other video categories -->
        <section class="video-section" *ngIf="networkVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Network</h2>

          </div>

          <div class="video-grid">
            <div class="video-card" *ngFor="let video of networkVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>



        <!-- Additional sections for other video categories -->
        <section class="video-section" *ngIf="messageVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Message</h2>

          </div>

          <div class="video-grid">
            <div class="video-card" *ngFor="let video of messageVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>




        <!-- Additional sections for other video categories -->
        <section class="video-section" *ngIf="businessVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Network</h2>

          </div>

          <div class="video-grid">
            <div class="video-card" *ngFor="let video of businessVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>




        <!-- Additional sections for other video categories -->
        <section class="video-section" *ngIf="communityVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">Community</h2>

          </div>

          <div class="video-grid">
            <div class="video-card" *ngFor="let video of communityVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>



        <!-- Additional sections for other video categories -->
        <section class="video-section" *ngIf="generalVideos?.length > 0">
          <div class="section-header">
            <h2 class="section-title">General</h2>

          </div>

          <div class="video-grid">
            <div class="video-card" *ngFor="let video of generalVideos; let i = index"
              (click)="openVideo(video, templateVideo)">
              <div class="video-thumbnail">
                <video #videoElements muted>
                  <source [src]="video?.answer" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
                <div class="play-overlay">
                  <div class="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div class="duration-badge" *ngIf="video?.duration">{{video?.duration}}</div>
              </div>
              <div class="video-title">{{video?.question}}</div>
            </div>
          </div>
        </section>

      </div>

      <!-- Contact Section -->
      <div class="contact-section">
        <div class="contact-content">
          <div class="contact-icon">
            <ng-icon name="customDoubt"></ng-icon>
          </div>
          <h3 class="contact-title">Can't find what you are looking for?</h3>
          <p class="contact-subtitle">Reach out with questions or feedback anytime!</p>
          <button class="btn primary-btn contact-btn" (click)="ContactAdmin()">Contact Us</button>
        </div>
      </div>
    </div>
  </main>
</div>

<!-- Modern Video Modal -->
<div class="modern-video-modal" *ngIf="isVideoPaused" (click)="closeModel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">{{seletedVideo?.question}}</h3>
      <button class="modal-close" (click)="closeModel()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <video autoplay #videoPlayernew controls class="modal-video">
        <source [src]="seletedVideo?.answer" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</div>

<!-- Message Widget -->
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>